import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";
import Cookies from "js-cookie";
import { RetryOnError, verifyToken } from "../utilities/VerifyToken"
import { checkForAuthorization } from "utilities/index";

export const AddUserCollaborator = () => {
    return useMutation(({ payload, isEditMode }) => {
        return axios({
            method: isEditMode ? "put" : 'post',
            url: `${process.env.REACT_APP_BASE_URL}/startups/${isEditMode ? "edit" : "add"}-collaborator`,
            headers: {
                'Authorization': `Bearer ${checkForAuthorization()}`,
                'Content-type': 'application/json'
            },
            data: payload
        })
    }, {
        retry: 0,
        onError: (err) => {
            return verifyToken(err)
        },
    })
}

export const FetchAllUsersData = ({ startup_id, page = 1, limit = 10, searchText = "", enabled }) => {
    // console.log(id,"id")
    // console.log(page.page,page.search,"page")
    return useQuery(
        ['FetchAllUsersData-FetchAllUsersData-template-for-all-FetchAllUsersData-FetchAllUsersData-fetch' + startup_id, startup_id, page, limit, searchText],
        () => {
            return axios({
                method: 'get',
                url: `${process.env.REACT_APP_BASE_URL}/startups/collaborator-listing/${startup_id}?search=${searchText}&page=${page}&limit=${limit}`,
                headers: {
                    'Authorization': `Bearer ${checkForAuthorization()}`
                },
            })
        }, {
        // select: (data) => data,
        select: (data) => {
            // console.log(data,'values new')
            return { data: data?.data?.data, count: data?.data?.count, limit: Number(data?.data?.limit) }
        },
        enabled: !!startup_id && enabled,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
            return RetryOnError(failureCount, error)
        },
        onError: (err) => {
            return verifyToken(err)
        },
    })
}

export const FetchUserDataByID = ({ user_id }) => {
    return useQuery(
        ['master-FetchUserDataByID-FetchUserDataByID-FetchUserDataByID-using-id-FetchUserDataByID' + user_id, user_id],
        () => {
            return axios({
                method: 'get',
                url: `${process.env.REACT_APP_BASE_URL}/startups/collaborator-detail/${user_id}`,
                headers: {
                    'Authorization': `Bearer ${checkForAuthorization()}`
                },
            })
        }, {
        // select: (data) => data,
        select: (data) => {
            // console.log(data?.data?.data,'values new')
            const savedValues = data?.data?.data;

            if (Object.keys(savedValues)?.length > 0) {
                const savedData = { ...savedValues, ...savedValues?.data }
                delete savedData.data;
                return savedData;
            }
            else {
                return null;
            }

            // console.log(savedData,'values new')

            // return { data: savedData?.configuredMetrics ? savedData?.configuredMetrics : [], ...savedData }
        },
        refetchOnWindowFocus: false,
        enabled: !!user_id,
        retry: (failureCount, error) => {
            return RetryOnError(failureCount, error)
        },
        onError: (err) => {
            return verifyToken(err)
        },
    })
}

export const DeleteUserDataByID = () => {
    return useMutation(
        ({ user_id }) => {
            return axios({
                method: 'delete',
                url: `${process.env.REACT_APP_BASE_URL}/startups/delete-collaborator/${user_id}`,
                headers: {
                    Authorization: `Bearer ${checkForAuthorization()}`,
                    'Content-type': 'application/json'
                },
                // data: payload
            });
        },
        {
            retry: 0,
            // onSuccess: (data)=>console.log("API successfull"),
            // retry: (failureCount, error)=>{
            //   return RetryOnError(failureCount, error)
            // },
            onError: (err) => {
                return verifyToken(err);
            }
        }
    );
};

// Same-domain people waiting for approval to join this startup.
export const FetchDomainJoinRequests = ({ startup_id, enabled }) => {
    return useQuery(
        ['domain-join-requests', startup_id],
        () => axios({
            method: 'get',
            url: `${process.env.REACT_APP_BASE_URL}/startups/domain-join-requests/${startup_id}`,
            headers: { 'Authorization': `Bearer ${checkForAuthorization()}` },
        }),
        {
            select: (data) => data?.data?.data || [],
            enabled: !!startup_id && enabled,
            refetchOnWindowFocus: false,
            retry: (failureCount, error) => RetryOnError(failureCount, error),
            onError: (err) => verifyToken(err),
        }
    );
};

export const DecideDomainJoinRequest = () => {
    return useMutation(
        ({ request_id, action }) => axios({
            method: 'put',
            url: `${process.env.REACT_APP_BASE_URL}/startups/domain-join-request/${request_id}`,
            headers: { 'Authorization': `Bearer ${checkForAuthorization()}` },
            data: { action },
        }),
        { retry: 0, onError: (err) => verifyToken(err) }
    );
};
